import { createFileRoute } from '@tanstack/react-router';
import { PageContainer } from '@/components/shared/PageContainer';
import { queryClient } from '@/lib/utils/queryClient';
import { BadgesTable } from '../-components/BadgesTable';
import { EditBadgeSheet } from '../-components/EditBadgeSheet';
import { badgesQueryOptions } from '../-hooks/useBadges';
import { useBadgesPage } from '../-hooks/useBadgesPage';
import { useEditBadge } from '../-hooks/useEditBadge';

export const Route = createFileRoute('/management/badges/(pages)/')({
  // The list is unpaginated, so a single warm-the-cache prefetch is all the
  // loader needs — no search params to read.
  // The rejection is swallowed on purpose. The loader is a prefetch — its only
  // job is to have the list already warm when the component mounts. Letting it
  // reject hands the route to the router's error boundary, which replaces the
  // whole page; the table's own "Could not load…" banner then never renders,
  // and that banner is what stops a failed load from reading as an empty
  // system. The component's `useQuery` hits the same failure and surfaces it
  // inline. Verified by the Playwright spec, which asserts the banner.
  loader: () =>
    queryClient.ensureQueryData(badgesQueryOptions()).catch(() => undefined),
  component: BadgesPage,
});

function BadgesPage() {
  const page = useBadgesPage();
  const editor = useEditBadge(page.editId);

  return (
    <PageContainer>
      <BadgesTable page={page} />

      <EditBadgeSheet
        open={page.editId !== null}
        onOpenChange={open => !open && page.closeEdit()}
        editor={editor}
      />
    </PageContainer>
  );
}
